class MathPrecisionTool {
    static toPrecision(value, options) {
        var _a;
        const precision = Math.pow(10, (_a = options === null || options === void 0 ? void 0 : options.numberOfDecimalPlaces) !== null && _a !== void 0 ? _a : 2);
        return Math.round((value + Number.EPSILON) * precision) / precision;
    }
}

export { MathPrecisionTool as M };
//# sourceMappingURL=mathPrecisionTool-7b91146f.js.map
